module.exports = __webpack_public_path__ + "e35ddc7cb6794e3726c443501a67be98.svg";